import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { useTranslation } from "react-i18next";
import { post } from "../../../../../utils/helpers/api";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";

function CreateExpenseCategoryModal({ isOpen, toggle, onSave, categoryToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [categoryData, setCategoryData] = useState({
    name: categoryToEdit?.name || null,
    description: categoryToEdit?.description || null
  });

  useEffect(() => {
    if(categoryToEdit) {
      setCategoryData({
        name: categoryToEdit?.name || null,
        description: categoryToEdit?.description || null
      });
    } else {
      setCategoryData({
        name: null,
        description: null
      });
    }
  }, [categoryToEdit, isOpen]);

  const saveCategory = async () => {
    setSaveLoading(true);
    const url = categoryToEdit ? `/accounting/expense-categories/update/${categoryToEdit.id}` : '/accounting/expense-categories/store';
    const data = await post(url, categoryData)
    if(data?.success) {
      onSave();
      toggle();
      toast.success(categoryToEdit ? t('accounting.categoryUpdated') : t('accounting.categoryCreated'));
    } else {
      toast.error(data?.message || t('common.somethingWentWrong'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>{categoryToEdit ? t('accounting.editExpenseCategory') : t('accounting.newExpenseCategory')}</ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input
            value={categoryData?.name}
            onChange={e => setCategoryData({...categoryData, name: e.target.value})}
          />
        </FormGroup>
        <div>
          <Label>{t('common.description')}: </Label>
          <Input 
            type="textarea" 
            value={categoryData?.description}
            onChange={e => setCategoryData({...categoryData, description: e.target.value})}
          />
        </div>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveCategory}
          loading={saveLoading}
          disabled={saveLoading || !categoryData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateExpenseCategoryModal;